module.exports = __webpack_public_path__ + "images/emoji/headphones.268e9279b96030c843e3.png";